import moment from 'moment-timezone';

export const TIMEZONE_OPTIONS = moment.tz.names().map((name) => ({
  label: `UTC ${moment().tz(name).format('Z')} - ${name}`,
  value: name,
})).sort((a, b) => a.label > b.label ? 1 : -1);
